import { StatusTag } from 'components';
import { getDossierOperationStatusColor } from 'const/statutsDossierOperation';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { OperationStatus, OperationStatusKeys } from 'types/Operation';

export default function OperationStatusTag({
  full = false,
  status,
}: {
  status?: OperationStatus;
  full?: boolean;
}) {
  const { t } = useTranslation();

  if (!status) {
    return null;
  }

  return (
    <StatusTag
      full={full}
      status={t(
        `statuts_operation:${OperationStatusKeys[status.toLowerCase()]}`,
      )}
      color={getDossierOperationStatusColor(status)}
      className="!py-1 !-my-0 !px-3 align-middle"
    />
  );
}
